import { QueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

const queryErrorhandler = (error) => {
  const errorStatus = error?.request?.status;
  const title = errorStatus === 400 && 'خطای ارتباط با سرور!';
  toast.dismiss();
  toast.error(title, {
    position: 'top-right',
    autoClose: 2500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: 0,
    theme: 'light',
    limit: 0
  });
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      onError: (error) => {
        console.log(error);
      }
    }
  }
});
